import $ from 'jquery'

export const PopMenu = {
  HOOK_ROOT: '.js-pop-menu',
  HOOK_TRIGGER: '.js-pop-menu_trigger',
  HOOK_CONTAINER: '.js-pop-menu_container',
  HOOK_CLOSE: '.js-pop-menu_close',
  isActive: false,

  init: function () {
    $(document).on('click', PopMenu.HOOK_TRIGGER, PopMenu.toggle)
    $(document).on('click', PopMenu.HOOK_CLOSE, PopMenu.closeAll)
  },

  toggle: function (event) {
    event.preventDefault()

    const $container = $(this).siblings(PopMenu.HOOK_CONTAINER)

    // If there's an active pop menu and it's not the current target
    if (PopMenu.isActive) {
      // Check if this is the currently active pop menu
      const isCurrentTarget = !$container.hasClass('is-hidden')

      // Disable active pop menu
      $(PopMenu.HOOK_TRIGGER).removeClass('pop-menu_action--is-active')
      $(PopMenu.HOOK_CONTAINER).addClass('is-hidden')

      // If this isn't the current target show the new pop menu
      if (!isCurrentTarget) {
        $(this).addClass('pop-menu_action--is-active')
        $container.removeClass('is-hidden')
      }
    } else {
      // Show pop menu
      $(this).addClass('pop-menu_action--is-active')
      $container.removeClass('is-hidden')

      // Set states and bind body click event
      $(document).on('click', PopMenu.bodyClick)
      PopMenu.isActive = true
    }
  },

  closeAll: function (event) {
    if (typeof event !== 'undefined') {
      event.preventDefault()
    }

    // Hide active pop menus
    $(PopMenu.HOOK_CONTAINER).addClass('is-hidden')

    // Remove active class modifier from trigger
    $(PopMenu.HOOK_TRIGGER).removeClass('pop-menu_action--is-active')

    // Unbind body click event
    $(document).off('click', PopMenu.bodyClick)

    PopMenu.isActive = false
  },

  bodyClick: function (event) {
    const currentEl = event.target

    // Make sure the pop menu container component is being clicked
    if (
      !$(currentEl).is(
        PopMenu.HOOK_CONTAINER +
          ' *, ' +
          PopMenu.HOOK_CONTAINER +
          ', ' +
          PopMenu.HOOK_TRIGGER
      )
    ) {
      PopMenu.closeAll()
      PopMenu.isActive = false
    }
  },
}

$(PopMenu.init)
